import get from 'lodash/get';
import React from 'react';
import {
    Controller,
    ControllerFieldState,
    ControllerRenderProps,
    FieldValues,
    useFormContext,
    UseFormStateReturn,
} from 'react-hook-form';
import styled from 'styled-components';

import { IconLockOutline } from '../../icon';
import { HorizontalLayout } from '../../Layout';
import { useFieldValidation } from '../Form';
import { FormElement, FormLabel, InputDescription } from './FormCommons';

export interface CommonInputProps {
    name: string;
    label?: string;
    description?: string;
    vertical?: boolean;
    disabled?: boolean;
    hideLabel?: boolean;
    onBlur?: (ev: React.FocusEvent<HTMLInputElement>) => void;
    onFocus?: (ev: React.FocusEvent<HTMLInputElement>) => void;
}

interface FormInputWrapperProps extends CommonInputProps {
    fieldRenderer: ({
        field,
        fieldState,
        formState,
    }: {
        field: ControllerRenderProps<FieldValues, string>;
        fieldState: ControllerFieldState;
        formState: UseFormStateReturn<FieldValues>;
    }) => JSX.Element;
}
export const FormInputWrapper = ({
    name,
    label,
    description,
    vertical = false,
    disabled = false,
    hideLabel,
    fieldRenderer,
}: FormInputWrapperProps) => {
    const {
        formState: { errors },
    } = useFormContext();

    const error = get(errors, name);
    const { isRequired } = useFieldValidation(name);

    return (
        <FormElement $isVertical={vertical} $hideLabel={hideLabel}>
            {!hideLabel && (
                <FormLabel htmlFor={name}>
                    {label}
                    {isRequired && '*'}
                </FormLabel>
            )}

            <InputWrapper $stretch>
                <IconContainer>{disabled && <IconLockOutline size="xSmall" />}</IconContainer>
                <Controller render={fieldRenderer} name={name} />
            </InputWrapper>
            <InputDescription errorMessage={error?.message} description={description} />
        </FormElement>
    );
};

const IconContainer = styled.div`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 9px;
    z-index: 1;
`;

const InputWrapper = styled(HorizontalLayout)`
    position: relative;
`;
